export enum EAppAccountType {
  ALL = 'ALL',
  SHIPKEY = 'shipkey',
  SHIPSTATION = 'shipstation',
  SHOPIFY = 'shopify',
  EDI = 'edi',
  TRACKSTAR = 'trackstar',
  HUBSPOT = 'hubspot',
  VESYL = 'vesyl',
  NUORDER = 'nuorder',
  ECART = 'ecart',
  ETSY = 'etsy',
  FAIRE = 'faire',
}

export enum EAppAccountAuthType {
  API_KEYS = 'API_KEYS',
  API_TOKEN = 'API_TOKEN',
  SHOPIFY_KEYS = 'SHOPIFY_KEYS',
  EDI_KEYS = 'EDI_KEYS',
  OAUTH = 'OAUTH',
}

export enum ETrackstarEnvironment {
  PRODUCTION = 'PRODUCTION',
  SANDBOX = 'SANDBOX',
}
